import React from "react";
import { Rate } from "antd"; // Assuming you're using Ant Design's Rate component
import Modal from "../modal";
import Loader from "../loader";

const ReviewModal = ({
  show,
  onCancel,
  onSubmit,
  loading,
  reviewAndRatingDetail,
  setReviewAndRatingDetail,
}) => {
  return (
    <Modal zIndex={10000} title="Please Rate" show={show} onCancel={onCancel}>
      <h6>Rating</h6>
      <Rate
        defaultValue={2}
        value={reviewAndRatingDetail?.rating}
        onChange={(e) =>
          setReviewAndRatingDetail((prevState) => ({
            ...prevState,
            rating: e,
          }))
        }
        style={{ fontSize: "17px" }}
      />

      <h6 className="mt-3">Review</h6>
      <textarea
        className="form-control mb-3"
        autoFocus
        rows="4"
        value={reviewAndRatingDetail?.review || ""}
        onChange={(e) =>
          setReviewAndRatingDetail((prevState) => ({
            ...prevState,
            review: e.target.value,
          }))
        }
      ></textarea>

      <div className="d-flex justify-content-end">
        <button
          onClick={onCancel}
          disabled={loading}
          className="btn btn_outlined me-2"
        >
          Cancel
        </button>
        <button
          onClick={() => onSubmit(reviewAndRatingDetail)}
          disabled={loading}
          className="btn btn-primary btn_contained"
        >
          {loading ? <Loader /> : "Proceed"}
        </button>
      </div>
    </Modal>
  );
};

export default ReviewModal;
